import React, { useEffect, useState } from "react";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import {
  Card,
  CardBody,
  Col,
  Container,
  CardHeader,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Input,
  Label,
  FormFeedback,
  Form,
  Button,
  Table,
} from "reactstrap";
import { useFormik, useFormikContext, FieldArray } from "formik";
import * as Yup from "yup";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { createPlanSubscription, getProduct, listPlanFeature, listSpeacification, listVariant } from "./_requests";
import classnames from 'classnames';
import CropModal from "../../Components/Common/CropModal";
import { useProfile } from "../../Components/Hooks/UserHooks";
import { useToast } from "../../Components/Common/ToastContext";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Select from "react-select";
import Dropzone from "react-dropzone";

const AddPlanSubscription = (props: any) => {
  document.title = " Paal Dappa | Admin panel";
  const { userProfile } = useProfile();
  const { showToast } = useToast();
  const history = useNavigate();
  const location = useLocation();
  const nextOrder = location.state?.nextOrder || 1;
  const [selectedFeatures, setSelectedFeatures] = useState<number[]>([]);
  const [newGalleryFiles, setNewGalleryFiles] = useState<any[]>([]);

  const validation: any = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: "",
      type: 1,
      no_of_times_used: 0,
      no_of_delivery_days: 0,
      referral_status: true,
      is_trial_plan: false,
      is_subscription: true,
      max_cancel_validity_days: 30,
      validity_type: "Days",
      max_purchase_count: 0,
      max_purchase_product: 0,
      list_order: nextOrder,
      plan_feature_id: "",
      image: null, // Ensure image is included in initialValues
      description: "",
      details: [
        {
          is_loyalty_bonus: false,
          product_id: 0,
          variant_id: 0,
          variant_value: 0,
          validity: 0,
          free_validity_days: 0,
          validity_type: "Days",
          actual_amount: 0,
          per_day_amount: 0,
          offer_value: 0,
          offer_type: 0,
          offer_amount: 0,
          gross_amount: 0,
          productPriceId: 0,
          category_id: 0,
        },
      ],
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter a Plan Name"),
      type: Yup.number()
        .typeError("Allowed numbers only, characters are not allowed")
        .required("Please Select Plan Type"),
      max_cancel_validity_days: Yup.number()
        .typeError("Allowed numbers only, characters are not allowed")
        .moreThan(0, "Please Enter Maximum Cancel days")
        .required("Please Maximum Cancel days"),

      no_of_delivery_days: Yup.number()
        .typeError("Allowed numbers only, characters are not allowed")
        // .moreThan(0, "Please enter the maximum delivery days received through referral for this plan (e.g., 15 days).")
        .required("Please enter the maximum delivery days received through referral for this plan (e.g., 15 days)."),
      no_of_times_used: Yup.number()
        .typeError("Allowed numbers only, characters are not allowed")
        // .moreThan(0, "Please enter the no of times used this plan through referral (e.g., 1 or 2  time).")
        .required("Please enter the no of times used this plan through referral (e.g., 1 or 2  time)."),
      validity_type: Yup.string().required("Please Select Validity Type"),
      list_order: Yup.number().typeError("Allowed numbers only").required("Please Enter List Order"),
      plan_feature_id: Yup.mixed()
        .test(
          "is-string-or-array",
          "Please Select Plan Features",
          (value) => typeof value === "string" || Array.isArray(value)
        )
        .required("Please Select Plan Features"),
      description: Yup.string().required("Please Enter Description"),
      image: Yup.mixed()
        .when("type", {
          is: (val: any) => Number(val) === 3,
          then: (schema) => schema.required("Please Select Image"),
          otherwise: (schema) => schema.notRequired(),
        })
        .test("dimensions", "Trial plan image dimensions are incorrect", function (value) {
          const { type } = this.parent;
          if (type !== 3 || !value || typeof value === "string") return true;

          return new Promise((resolve) => {
            const img = new Image();
            img.src = URL.createObjectURL(value as File);
            img.onload = () => {
              const isValid = img.width === 1512 && img.height === 448;
              if (!isValid) {
                // We can even customize the error message here
                resolve(this.createError({ message: `Trial plan image must be exactly 1512px (Width) * 448px (Height) (Selected image size ${img.width}px * ${img.height}px)` }));
              } else {
                resolve(true);
              }
            };
            img.onerror = () => resolve(this.createError({ message: "Invalid image file" }));
          });
        }),
      max_purchase_count: Yup.number()
        .typeError("Allowed numbers only")
        .when("type", {
          is: (val: any) => Number(val) === 3,
          then: (schema) => schema.required("Please Enter Max Order Count").min(1, "Must be at least 1"),
          otherwise: (schema) => schema.notRequired(),
        }),
      max_purchase_product: Yup.number()
        .typeError("Allowed numbers only")
        .when("type", {
          is: (val: any) => Number(val) === 3,
          then: (schema) =>
            schema
              .required("Please Enter Max Selectable Products")
              .min(1, "Must be at least 1")
              .test(
                "max-selectable",
                "Cannot exceed number of products added below",
                function (value) {
                  const { details } = this.parent;
                  const addedProductsCount = details?.filter((d: any) => d.product_id > 0).length || 0;
                  

  return (value || 0) <= addedProductsCount;
                }
              ),
          otherwise: (schema) => schema.notRequired(),
        }),
      details: Yup.array().of(
        Yup.object().shape({
          product_id: Yup.number()
            .typeError("Allowed numbers only, characters are not allowed")
            .moreThan(0, "Please Enter Product ID")
            .required("Please Enter Product ID"),
          variant_id: Yup.number()
            .typeError("Allowed numbers only, characters are notallowed")
            .moreThan(0, "Please Enter Variant ID")
            .required("Please Enter Variant ID"),
          variant_value: Yup.number()
            .typeError("Allowed numbers only, characters are not allowed")
            .moreThan(0, "Please Enter Variant Value (2 KG, 5 L, 500ML)")
            .required("Please Enter Variant Value (2 KG, 5 L, 500ML)"),
          validity: Yup.number()
            .typeError("Allowed numbers only, characters are not allowed")
            .moreThan(0, "Please Enter Validity")
            .required("Please Enter Validity"),
          validity_type: Yup.string().required("Please Enter Validity Type"),
          actual_amount: Yup.number()
            .typeError("Allowed numbers only, characters are not allowed")
            // .moreThan(0, "Please Enter Actual Amount")
            .required("Please Enter Actual Amount"),
          // Fix cyclic dependency by using .test instead of .when for cross-field validation
          offer_type: Yup.number()
            .typeError("Allowed numbers only, characters are not allowed")
            .test(
              "offer_type-required-if-offer_value",
              "Please Select Offer Type",
              function (value) {
                const { offer_value } = this.parent;
                if (
                  offer_value !== undefined &&
                  offer_value !== null &&
                  offer_value !== "" &&
                  Number(offer_value) !== 0
                ) {
                  return value !== undefined && value !== null && value !== 0;
                }
                return true;
              }
            ),
          offer_value: Yup.number()
            .typeError("Allowed numbers only, characters are not allowed")
            .test(
              "offer_value-required-if-offer_type",
              "Please Enter Offer Amount",
              function (value) {
                const { offer_type } = this.parent;
                if (
                  offer_type !== undefined &&
                  offer_type !== null &&
                  offer_type !== "" &&
                  Number(offer_type) !== 0
                ) {
                  return value !== undefined && value !== null && Number(value) !== 0;
                }
                return true;
              }
            ),
          gross_amount: Yup.number()
            .typeError("Allowed numbers only, characters are not allowed")
            .required("Please Enter Gross Amount"),
          productPriceId: Yup.number()
            .typeError("Allowed numbers only, characters are not allowed")
            .moreThan(0, "Please select a valid variant")
            .required("Please Enter Product Price ID"),
        })
      ),
    }),
    onSubmit: async (values) => {
      console.log("Form Values:", values);

      const formData = new FormData();
      formData.append("name", values.name);
      formData.append("validity_type", String(values.validity_type));
      formData.append("max_cancel_validity_days", String(values.max_cancel_validity_days));
      formData.append("no_of_delivery_days", String(values.no_of_delivery_days));
      formData.append("no_of_times_used", String(values.no_of_times_used));
      formData.append("referral_status", String(values.referral_status));
      formData.append("is_subscription", String(values.is_subscription));
      formData.append("is_trial_plan", String(values.is_trial_plan));
      formData.append("max_purchase_count", String(values.max_purchase_count));
      formData.append("max_purchase_product", String(values.max_purchase_product));
      formData.append("list_order", String(values.list_order));
      formData.append("type", String(values.type));
      formData.append(
        "plan_feature_id",
        Array.isArray(values.plan_feature_id)
          ? values.plan_feature_id.join(",")
          : values.plan_feature_id
      ); // Convert array to comma-separated string
      formData.append("description", values.description);
      if (values.image) {
        formData.append("image", values.image || "default.png"); // Ensure image is appended to formData
      }
      formData.append(
        "details",
        JSON.stringify(
          values.details.map((detail: any) => ({
            ...detail,
            is_loyalty_bonus: Boolean(detail.is_loyalty_bonus),
            product_id: Number(detail.product_id),
            category_id: Number(detail.category_id || 0),
            variant_value: Number(detail.variant_value),
            variant_id: Number(detail.variant_id),
            validity_type: String(detail.validity_type),
            validity: Number(detail.validity),
            free_validity_days: Number(detail.free_validity_days || 0),
            per_day_amount: Number(detail.per_day_amount),
            actual_amount: Number(detail.actual_amount),
            offer_value: Number(detail.offer_value),
            offer_type: Number(detail.offer_type),
            offer_amount: Number(detail.offer_amount),
            gross_amount: Number(detail.gross_amount),

          }))
        )
      );

      // Append gallery files - Force flatten to handle any potential nesting issues
      const flatGalleryFiles = newGalleryFiles.flat(Infinity);
      flatGalleryFiles.forEach((file: any) => {
        if (file instanceof File || (file && file.preview)) {
          formData.append("gallery", file);
          formData.append("gallery_list_order", file.list_order || 0);
        }
      });

      if (userProfile && userProfile.id) {
        formData.append("created_by", userProfile.id);
      }

      console.log("FormData Diagnostic:");
      for (let pair of (formData as any).entries()) {
        console.log(`- ${pair[0]}: ${pair[1] instanceof File ? `File [${pair[1].name}, ${pair[1].size} bytes]` : pair[1]}`);
      }

      try {
        const res: any = await createPlanSubscription(formData);
        console.log("API Response: createPlanSubscription", res);
        console.log("res", res)
        console.log("res.data", res.data)
        console.log("res.status == true", res.status == true)
        if (res.status == true) {
          toast.success(res.message, res.status);
          validation.resetForm();
          history("/plan-subscription");
        } else {
          toast.error(res.message, res.status);
        }
      } catch (error) {
        console.error("Error in form submission:", error);
      }
    },
  });


  // Log when type changes and validate image dimensions for Trial
  useEffect(() => {
    console.log("Plan type changed:", validation.values.type,
      "Is trial plan:", validation.values.is_trial_plan);
    
    if (validation.values.type === 3 && validation.values.image) {
      const file = validation.values.image;
      if (file instanceof File) {
        const img = new Image();
        img.src = URL.createObjectURL(file);
        img.onload = () => {
          if (img.width !== 1512 || img.height !== 448) {
            validation.setFieldError("image", `Trial plan image must be exactly 1512px (Width) * 448px (Height) (Selected image size ${img.width}px * ${img.height}px)`);
          } else {
            validation.setFieldError("image", "");
          }
        };
      }
    } else if (validation.values.type !== 3 && validation.errors.image && validation.errors.image.includes("Trial plan image must be exactly 1512px (Width) * 448px (Height)")) {
      validation.setFieldError("image", "");
    }
  }, [validation.values.type, validation.values.image]);
  
  // Log when details array changes
  useEffect(() => {
    console.log("Plan details updated:", validation.values.details);
  }, [validation.values.details]);
  // Add this function near your other utility functions
  const logFormikState = () => {
    console.group("Formik State");
    console.log("Values:", validation.values);
    console.log("Errors:", validation.errors);
    console.log("Touched:", validation.touched);
    console.log("IsSubmitting:", validation.isSubmitting);
    console.log("IsValid:", validation.isValid);
    console.log("Dirty:", validation.dirty);
    console.groupEnd();
  };

  // Then use it in your useEffect
  useEffect(() => {
    logFormikState();
  }, [validation.values, validation.errors, validation.touched]);
  const [customActiveTab, setcustomActiveTab] = useState<any>("1");
  const toggleCustom = (tab: any) => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab);
    }
  };

  const [availableFeature, setAvailableFeature] = useState<any[]>([]);
  const [availableVariants, setAvailableVariants] = useState<any[]>([]);
  console.log("availableFeature", availableFeature)

  const [previewImage, setPreviewImage] = useState<string | null>(null);
  const [selectedFiles, setSelectedFiles] = useState<File | null>(null);
  
  // Cropper states
  const [cropModal, setCropModal] = useState<boolean>(false);
  const [imageToCrop, setImageToCrop] = useState<string | null>(null);
  
  const [productList, setProductList] = useState<any[]>([]);

  const handleAcceptedFiles = (files: any) => {
    const formattedFiles = files.map((file: any, index: number) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        id: Math.random(),
        list_order: newGalleryFiles.length + index + 1
      })
    );
    setNewGalleryFiles(prev => [...prev.flat(Infinity), ...formattedFiles]);
  };

  const removeGallery = (id: any) => {
    setNewGalleryFiles(prev => {
      const filtered = prev.filter(img => img.id !== id);
      // Re-sequence remaining items to fill the gap
      return filtered
        .sort((a, b) => (a.list_order || 0) - (b.list_order || 0))
        .map((img, index) => ({ ...img, list_order: index + 1 }));
    });
  };

  const handleGalleryOrderChange = (id: any, order: any) => {
    let newOrder = parseInt(order) || 1;
    const totalItems = newGalleryFiles.length;
    
    // Cap the order at the total number of items
    if (newOrder > totalItems) newOrder = totalItems;
    if (newOrder < 1) newOrder = 1;

    setNewGalleryFiles(prev => {
      const targetItem = prev.find(img => img.id === id);
      if (!targetItem) return prev;
      const oldOrder = targetItem.list_order || 0;
      
      return prev.map(img => {
        let currentOrder = img.list_order || 0;
        if (img.id === id) {
          return { ...img, list_order: newOrder };
        }
        if (newOrder < oldOrder) {
          // Moving up: shift items in between down
          if (currentOrder >= newOrder && currentOrder < oldOrder) {
            return { ...img, list_order: currentOrder + 1 };
          }
        } else if (newOrder > oldOrder) {
          // Moving down: shift items in between up
          if (currentOrder > oldOrder && currentOrder <= newOrder) {
            return { ...img, list_order: currentOrder - 1 };
          }
        }
        return img;
      });
    });
  };

  useEffect(() => {

    listVariant().then((res: any) => {
      setAvailableVariants(res.data || []);
    });
    listPlanFeature().then((res: any) => {
      setAvailableFeature(res.data || []);

      getProduct().then((res: any) => {
        setProductList(res.data || []);
      });
    });

    // Cleanup function (if needed)
    return () => { };
  }, []);

  const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files && files[0]) {
      const file = files[0];
      const isTrial = validation.values.type === 3;

      if (isTrial) {
        const reader = new FileReader();
        reader.onload = (e) => {
          if (e.target?.result) {
            setImageToCrop(e.target.result as string);
            setCropModal(true);
          }
        };
        reader.readAsDataURL(file);
        event.target.value = "";
      } else {
        // Non-trial plans don't strictly require cropping but we can still set it
        setSelectedFiles(file);
        validation.setFieldValue("image", file);
        const reader = new FileReader();
        reader.onload = (e) => {
          if (e.target?.result) setPreviewImage(e.target.result as string);
        };
        reader.readAsDataURL(file);
      }
    }
  };

  const handleCropSave = (croppedFile: File) => {
    setSelectedFiles(croppedFile);
    validation.setFieldValue("image", croppedFile);
    setPreviewImage(URL.createObjectURL(croppedFile));
    validation.setFieldError("image", "");
  };

  const handleRemoveImage = () => {
    setPreviewImage(null);
    setSelectedFiles(null);
    validation.setFieldValue("image", null); // Reset formik value
  };
  const handleAddRow = () => {
    validation.setFieldValue("details", [
      ...validation.values.details,
      { is_loyalty_bonus: false, product_id: 0, variant_id: 0, category_id: 0, validity: 0, free_validity_days: 0, validity_type: "Days", per_day_amount: 0, actual_amount: 0, offer_value: 0, gross_amount: 0, offer_amount: 0, productPriceId: 0 }
    ]);
  };

  const handleRemoveRow = (index: any) => {
    const updatedRows = [...validation.values.details];
    updatedRows.splice(index, 1);
    validation.setFieldValue("details", updatedRows);
  };


  const scrollToError = (errors: any) => {
    const errorFields = Object.keys(errors);
    if (errorFields.length > 0) {
      const errorElement = document.querySelector(`[name="${errorFields[0]}"]`);
      if (errorElement) {
        errorElement.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  };

  const scrollToArrayError = (errors: any) => {
    const errorFields = Object.keys(errors);
    if (errorFields.length > 0) {
      const errorElement = document.querySelector(`[name="${errorFields[0]}"]`);
      if (errorElement) {
        errorElement.scrollIntoView({ behavior: "smooth", block: "center" });
      } else {
        for (const field of errorFields) {
          if (Array.isArray(errors[field])) {
            const nestedErrorElement = document.querySelector(`[name="${field}[0]"]`);
            if (nestedErrorElement) {
              nestedErrorElement.scrollIntoView({ behavior: "smooth", block: "center" });
              break;
            }
          }
        }
      }
    }
  };


  const handleProductChange = (index: number, productId: number) => {
    const product = productList.find((p) => p.id === productId);
    const usedVariantIds = validation.values.details
      .filter((d: any, i: number) => i !== index && Number(d.product_id) === productId)
      .map((d: any) => Number(d.productPriceId));

    const totalVariants = product?.variants || [];
    const availableVariantsCount = totalVariants.filter((v: any) => !usedVariantIds.includes(Number(v.id))).length;

    if (availableVariantsCount === 0) {
      toast.error("no have remaining variants");
      // Allow selection so the message can be shown below the dropdown
    }

    const updatedDetails = [...validation.values.details];
    updatedDetails[index] = {
      ...updatedDetails[index],
      product_id: productId,
      category_id: product?.categoryId || 0,
      variant_id: 0,
      variant_value: 0,
      productPriceId: 0,
      per_day_amount: 0,
      actual_amount: 0,
    };
    validation.setFieldValue("details", updatedDetails);
  };



  const handleVariantChange = (index: number, productPriceId: number) => {
    const detail = validation.values.details[index];
    const productId = detail.product_id;
    const product = productList.find((p) => p.id === productId);
    const variantPrice = product?.variants?.find((v: any) => v.id === productPriceId);

    if (variantPrice) {
      const updatedDetail = {
        ...detail,
        productPriceId: variantPrice.id,
        variant_id: variantPrice.variant_id,
        variant_value: variantPrice.variant_value,
        per_day_amount: variantPrice.actual_amount,
      };

      // Trigger amount recalculation for the new per_day_amount using the updated detail
      handleCombinationChange(index, "per_day_amount", variantPrice.actual_amount, updatedDetail);
    }
  };

  const handleCombinationChange = (index: number, field: string, value: any, baseDetail?: any) => {
    const updatedDetails = [...validation.values.details];
    const detail = {
      ...(baseDetail || updatedDetails[index]),
      [field]: value,
    };

    // Safely parse numeric values, removing any non-numeric characters like currency symbols
    const perDay = parseFloat(String(detail.per_day_amount || "0").replace(/[^0-9.]/g, ""));
    const validity = parseFloat(String(detail.validity || "0").replace(/[^0-9.]/g, ""));
    const freeDays = parseFloat(String(detail.free_validity_days || "0").replace(/[^0-9.]/g, ""));

    // Recalculate Actual Amount
    const actualAmount = (validity + freeDays) * perDay;
    detail.actual_amount = actualAmount.toFixed(2);

    if (field === "gross_amount") {
      // When gross_amount is changed directly, back-calculate the discount/offer details
      const grossAmount = parseFloat(String(value || "0").replace(/[^0-9.]/g, ""));
      const offerAmount = actualAmount - grossAmount;
      detail.offer_amount = Math.max(0, offerAmount).toFixed(2);

      const offerType = parseInt(detail.offer_type || "0");
      if (offerType === 1) {
        detail.offer_value = detail.offer_amount;
      } else if (offerType === 2 && actualAmount > 0) {
        detail.offer_value = ((offerAmount / actualAmount) * 100).toFixed(2);
      }
    } else {
      // Auto-calculate offer and gross amount based on offer settings
      const offerType = parseInt(detail.offer_type || "0");
      let offerValue = parseFloat(String(detail.offer_value || "0").replace(/[^0-9.]/g, ""));

      // Validations
      if (offerType === 1 && offerValue > actualAmount) {
        toast.error(`Offer Amount cannot exceed Total Actual Amount (${actualAmount.toFixed(2)})`);
        offerValue = actualAmount;
        detail.offer_value = actualAmount.toFixed(2);
      } else if (offerType === 2 && offerValue > 100) {
        toast.error("Offer Percentage cannot exceed 100%");
        offerValue = 100;
        detail.offer_value = "100.00";
      }

      let calculatedOfferAmount = 0;

      if (freeDays > 0) {
        // Free days take precedence over other offers
        calculatedOfferAmount = freeDays * perDay;
        detail.offer_type = 2; // Represent as percentage for consistency
        detail.offer_value = actualAmount > 0 ? ((calculatedOfferAmount / actualAmount) * 100).toFixed(2) : "0.00";
      } else if (offerType === 1) {
        // Fixed amount discount
        calculatedOfferAmount = offerValue;
      } else if (offerType === 2) {
        // Percentage discount
        calculatedOfferAmount = (actualAmount * offerValue) / 100;
      } else {
        // Reset offer value when type is set to 0
        detail.offer_value = 0;
        calculatedOfferAmount = 0;
      }
      detail.offer_amount = calculatedOfferAmount.toFixed(2);
      detail.gross_amount = Math.max(0, actualAmount - calculatedOfferAmount).toFixed(2);
    }

    updatedDetails[index] = detail;
    validation.setFieldValue("details", updatedDetails);
  };



  return (
    <div className="page-content">
      <ToastContainer closeButton={false} limit={1} />
      <Container fluid>
        <BreadCrumb title="Create Subscription Products" pageTitle="Paal Dappa" />


        <Form
          onSubmit={(e) => {
            e.preventDefault(); // Prevent default form submission
            validation.handleSubmit(); // Call Formik's handleSubmit
            if (Object.keys(validation.errors).length > 0) {
              console.log("Validation Errors:", validation.errors); // Log validation errors
              scrollToError(validation.errors);
              scrollToArrayError(validation.errors);
            }
          }}
        >
          <Row>
            <Col lg={8}>
              <Card>
                <CardBody>
                  <div className="mb-3">
                    <Label className="form-label" htmlFor="product-title-input">
                      Plan Name  <span className="text-danger">*</span>
                    </Label>
                    <Input
                      type="text"
                      className="form-control"
                      id="product-title-input"
                      placeholder="Enter Plan Name"
                      name="name"
                      value={validation.values.name || ""}
                      onBlur={validation.handleBlur}
                      onChange={validation.handleChange}
                      invalid={
                        validation.errors.name && validation.touched.name
                          ? true
                          : false
                      }
                    />
                    {validation.errors.name && validation.touched.name ? (
                      <FormFeedback type="invalid">
                        {validation.errors.name}
                      </FormFeedback>
                    ) : null}
                  </div>
                  <div>
                    <Label>Plan Description  <span className="text-danger">*</span></Label>
                    <ReactQuill
                      theme="snow"
                      value={validation.values.description}
                      onChange={(value: any) => validation.setFieldValue("description", value)}
                      modules={{
                        toolbar: [
                          [{ header: [1, 2, 3, false] }],
                          [{ font: [] }],
                          [{ size: ["small", false, "large", "huge"] }],
                          [{ color: [] }, { background: [] }],
                          ["bold", "italic", "underline"],
                          [{ list: "ordered" }, { list: "bullet" }],
                          [{ align: [] }],
                          ["link", "image"],
                          ["clean"],
                        ],
                      }}
                      formats={[
                        "header",
                        "font",
                        "size",
                        "color",
                        "background",
                        "bold",
                        "italic",
                        "underline",
                        "list",
                        "bullet",
                        "align",
                        "link",
                        "image",
                      ]}
                    />
                    {validation.errors.description && validation.touched.description ? (
                      <FormFeedback type="invalid">
                        {validation.errors.description}
                      </FormFeedback>
                    ) : null}
                  </div>
                </CardBody>
              </Card>
              <Card className="pb-4">
                <CardHeader>
                  <h5 className="card-title mb-0"> Image {validation.values.type === 3 && <span className="text-danger">*</span>}</h5>
                </CardHeader>
                <CardBody>
                  <div className="mb-4 text-center">
                    <div className="d-inline-block">
                      <div className="position-relative mb-3">
                        {/* Improved Preview Container */}
                        <div className="border rounded bg-light p-2 mx-auto" style={{ maxWidth: '400px', minWidth: '150px' }}>
                          {previewImage ? (
                            <div className="position-relative">
                              <img
                                src={previewImage}
                                id="product-img"
                                alt="Selected"
                                className="img-fluid rounded"
                                style={{ maxHeight: '200px', objectFit: 'contain' }}
                              />
                              <Button
                                type="button"
                                color="danger"
                                size="sm"
                                className="position-absolute top-0 end-0 rounded-circle"
                                style={{ transform: 'translate(50%, -50%)', padding: '0', width: '24px', height: '24px', minWidth: '24px' }}
                                onClick={handleRemoveImage}
                                title="Remove Image"
                              >
                                <i className="ri-close-line"></i>
                              </Button>
                            </div>
                          ) : (
                            <div className="py-4 text-muted">
                              <i className="ri-image-line display-4 d-block mb-2"></i>
                              <span>No Image Selected</span>
                            </div>
                          )}
                        </div>

                        {/* Structured Action Buttons */}
                        <div className="mt-3 d-flex justify-content-center gap-2">
                          <Label
                            htmlFor="type-image-input"
                            className="btn btn-light btn-sm border d-flex align-items-center gap-1 cursor-pointer mb-0"
                            title="Upload/Change Image"
                          >
                            <i className="ri-image-add-line"></i>
                            {previewImage ? "Change" : "Select"} Image
                          </Label>

                          {previewImage && validation.values.type === 3 && (
                            <Button
                              type="button"
                              color="primary"
                              size="sm"
                              outline
                              className="d-flex align-items-center gap-1"
                              onClick={() => {
                                setImageToCrop(previewImage);
                                setCropModal(true);
                              }}
                              title="Crop Trial Image"
                            >
                              <i className="ri-crop-2-line"></i> Crop
                            </Button>
                          )}
                        </div>

                        <Input
                          name="formImage"
                          className="form-control d-none"
                          id="type-image-input"
                          type="file"
                          accept="image/png, image/gif, image/jpeg"
                          onChange={handleImageChange}
                        />
                      </div>
                    </div>

                    {/* Required Size Hint - Styled as a badge for better visibility */}
                    {validation.values.type === 3 && (
                      <div className="mt-2">
                        <span className="badge bg-info-subtle text-info p-2 fs-12">
                          <i className="ri-information-line me-1"></i>
                          Required: 1512px (W) × 448px (H)
                        </span>
                      </div>
                    )}

                    {/* Validation Feedback - Only show after submit attempt */}
                    {validation.submitCount > 0 && validation.errors.image ? (
                      <div className="text-danger mt-2" style={{ fontSize: '0.875em', display: 'block' }}>
                        <i className="ri-error-warning-line me-1"></i>
                        {validation.errors.image}
                      </div>
                    ) : null}
                  </div>

                </CardBody>
              </Card>
            </Col>
            <Col lg={4}>
              <Card>
                <CardHeader>
                  <h5 className="card-title mb-0">Plan type  <span className="text-danger">*</span></h5>
                </CardHeader>
                <CardBody>
                  <p className="text-muted mb-2">
                    {" "}
                    {/* <Link
                      to="#"
                      className="float-end text-decoration-underline"
                      onClick={() => console.log("Open Modal")}
                    >
                      Add New
                    </Link> */}
                    Select type
                  </p>
                  {/* <select
                    className={`form-control ${validation.errors.type && validation.touched.type ? "is-invalid" : ""}`}
                    id="price-select"
                    name="type"
                    aria-placeholder="Select offer type"
                    onBlur={validation.handleBlur}
                    onChange={validation.handleChange}
                    value={validation.values.type}
                  >
                    <option value="">Select Type</option>
                    <option value="1">Regular</option>
                    <option value="2">Combo</option>
                    <option value="3">Trial (Free)</option>
                  </select> */}
                  <select
                    className={`form-control ${validation.errors.type && validation.touched.type ? "is-invalid" : ""}`}
                    id="price-select"
                    name="type"
                    aria-placeholder="Select offer type"
                    onBlur={validation.handleBlur}
                    onChange={(e) => {
                      const value = parseInt(e.target.value);
                      validation.setFieldValue("type", value);
                      validation.setFieldValue("is_trial_plan", value == 3); // Set to true only for Trial (value 3)
                    }}
                    value={validation.values.type}
                  >
                    <option value="">Select Type</option>
                    <option value="1">Regular</option>
                    <option value="2">Combo</option>
                    <option value="3">Trial (Free)</option>
                  </select>

                  {validation.values.is_trial_plan ? (
                    <div className="alert alert-info mt-2">
                      <i className="ri-information-line me-2"></i>
                      This is a free trial plan - users won't be charged
                    </div>
                  ) : (
                    <div className="alert alert-warning mt-2">
                      <i className="ri-money-dollar-circle-line me-2"></i>
                      This is a paid plan - users will be charged
                    </div>
                  )}

                  {validation.touched.type && validation.errors.type ? (
                    <FormFeedback type="invalid">
                      {validation.errors.type}
                    </FormFeedback>
                  ) : null}
                </CardBody>
              </Card>
              <Card>
                <CardHeader>
                  <h5 className="card-title mb-0">Features  <span className="text-danger">*</span></h5>
                </CardHeader>
                <CardBody>
                  <p className="text-muted mb-2">
                    {/* <Link
                      to="#"
                      className="float-end text-decoration-underline"
                      onClick={() => console.log("Open Modal")}
                    >
                      Add New
                    </Link> */}
                    Select features
                  </p>
                  <Select
                    isMulti
                    name="plan_feature_id"
                    options={availableFeature.map((option) => ({
                      value: option.id,
                      label: option.name,
                    }))}
                    value={availableFeature
                      .filter((option) => selectedFeatures.includes(option.id))
                      .map((option) => ({ value: option.id, label: option.name }))}
                    onChange={(selectedOptions: any) => {
                      const selectedIds = selectedOptions.map((option: any) => option.value);
                      setSelectedFeatures(selectedIds);
                      validation.setFieldValue("plan_feature_id", selectedIds);
                    }}
                    classNamePrefix="react-select"
                  />
                  {validation.touched.plan_feature_id && validation.errors.plan_feature_id ? (
                    <FormFeedback type="invalid">
                      {validation.errors.plan_feature_id}
                    </FormFeedback>
                  ) : null}
                </CardBody>
              </Card>
              <Card>
                <CardHeader>
                  <h5 className="card-title mb-0">Validity Details <span className="text-danger">*</span></h5>
                </CardHeader>
                <CardBody>
                  <Row>
                    {/* Max Cancel Validity Days */}
                    <Col md={12}>
                      <div className="mb-3">
                        <Label htmlFor="max_cancel_validity_days" className="form-label">
                          Cancel Limit <span className="text-danger">*</span>
                        </Label>
                        <Input
                          type="number"
                          className="form-control"
                          id="max_cancel_validity_days"
                          placeholder="Enter days"
                          name="max_cancel_validity_days"
                          value={validation.values.max_cancel_validity_days || ""}
                          onBlur={validation.handleBlur}
                          onChange={validation.handleChange}
                          invalid={
                            validation.errors.max_cancel_validity_days &&
                            validation.touched.max_cancel_validity_days
                          }
                        />
                        {validation.errors.max_cancel_validity_days &&
                          validation.touched.max_cancel_validity_days ? (
                          <FormFeedback type="invalid">
                            {validation.errors.max_cancel_validity_days}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    {validation.values.type === 3 && (
                      <>
                        <Col md={6}>
                          <div className="mb-3">
                            <Label htmlFor="max_purchase_count" className="form-label">
                              Max Order Count <span className="text-danger">*</span>
                            </Label>
                            <Input
                              type="number"
                              className="form-control"
                              id="max_purchase_count"
                              placeholder="Example: 3"
                              name="max_purchase_count"
                              value={validation.values.max_purchase_count}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}
                              invalid={validation.touched.max_purchase_count && !!validation.errors.max_purchase_count}
                            />
                            <p className="text-muted small mt-1">(Maximum number of times a user can purchase this trial plan)</p>
                            {validation.errors.max_purchase_count && validation.touched.max_purchase_count ? (
                              <FormFeedback type="invalid">{validation.errors.max_purchase_count}</FormFeedback>
                            ) : null}
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="mb-3">
                            <Label htmlFor="max_purchase_product" className="form-label">
                              Max Selectable Products <span className="text-danger">*</span>
                            </Label>
                            <Input
                              type="number"
                              className="form-control"
                              id="max_purchase_product"
                              placeholder="Example: 1"
                              name="max_purchase_product"
                              value={validation.values.max_purchase_product}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}
                              invalid={validation.touched.max_purchase_product && !!validation.errors.max_purchase_product}
                            />
                            <p className="text-muted small mt-1">
                              (Limits how many different products a user can pick from the variants below. Example: If 3 products are listed and this is set to 1, the user can only choose any 1 product.)
                            </p>
                            {validation.errors.max_purchase_product && validation.touched.max_purchase_product ? (
                              <FormFeedback type="invalid">{validation.errors.max_purchase_product}</FormFeedback>
                            ) : null}
                          </div>
                        </Col>
                      </>
                    )}
                    <Col md={12}>
                      <div className="mb-3">
                        <Label htmlFor="list_order" className="form-label">
                          List Order <span className="text-danger">*</span>
                        </Label>
                        <Input
                          type="number"
                          className="form-control"
                          id="list_order"
                          placeholder="Enter order"
                          name="list_order"
                          value={validation.values.list_order}
                          onBlur={validation.handleBlur}
                          onChange={validation.handleChange}
                          invalid={validation.touched.list_order && !!validation.errors.list_order}
                        />
                        {validation.errors.list_order && validation.touched.list_order ? (
                          <FormFeedback type="invalid">{validation.errors.list_order}</FormFeedback>
                        ) : null}
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>


              <Card>
                <CardHeader className="d-flex justify-content-between align-items-center">
                  <h5 className="card-title mb-0">Subscription Settings <span className="text-danger">*</span></h5>


                  <div className="form-check form-switch">
                    <Input
                      type="switch"
                      id="is-subscription"
                      name="is_subscription"
                      checked={validation.values.is_subscription}
                      onChange={(e) => {
                        validation.setFieldValue("is_subscription", e.target.checked);
                      }}
                    />
                    <Label htmlFor="is-subscription" className="form-check-label">
                      {validation.values.is_subscription ? "Active" : "Inactive"}
                    </Label>
                  </div>

                </CardHeader>
                <CardBody className="mx-2">
                  <div className="alert alert-info mt-2 mx-2">
                    <i className="ri-information-line me-2"></i>
                    (It is not One time purchase means enable this)
                  </div>
                </CardBody>
              </Card>

              <Card>
                <CardHeader className="d-flex justify-content-between align-items-center">
                  <h5 className="card-title mb-0">Referral Details <span className="text-danger">*</span></h5>
                  <div className="form-check form-switch">
                    <Input
                      type="switch"
                      id="referral-status"
                      name="referral_status"
                      checked={validation.values.referral_status}
                      onChange={(e) => {
                        validation.setFieldValue("referral_status", e.target.checked);
                        // Reset values when turning off
                        if (!e.target.checked) {
                          validation.setFieldValue("no_of_delivery_days", 0);
                          validation.setFieldValue("no_of_times_used", 0);
                        }
                      }}
                    />
                    <Label htmlFor="referral-status" className="form-check-label">
                      {validation.values.referral_status ? "Active" : "Inactive"}
                    </Label>
                  </div>
                </CardHeader>
                <CardBody>
                  <Row>
                    {/* Max Referral Days */}
                    <Col md={7}>
                      <div className="mb-3">
                        <Label htmlFor="no_of_delivery_days" className="form-label">
                          Max Referral Days <span className="text-danger">*</span>
                        </Label>
                        <Input
                          type="number"
                          className="form-control"
                          id="no_of_delivery_days"
                          placeholder="Enter No of delivery Days to Referral"
                          name="no_of_delivery_days"
                          value={validation.values.no_of_delivery_days || ""}
                          onBlur={validation.handleBlur}
                          onChange={validation.handleChange}
                          invalid={
                            validation.errors.no_of_delivery_days &&
                            validation.touched.no_of_delivery_days
                          }
                          disabled={!validation.values.referral_status}
                        />
                        {validation.errors.no_of_delivery_days &&
                          validation.touched.no_of_delivery_days ? (
                          <FormFeedback type="invalid">
                            {validation.errors.no_of_delivery_days}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </Col>

                    {/* No of times can be used */}
                    <Col md={5}>
                      <div className="mb-3">
                        <Label htmlFor="no_of_times_used" className="form-label">
                          No of times can be used <span className="text-danger">*</span>
                        </Label>
                        <Input
                          type="number"
                          className="form-control"
                          id="no_of_times_used"
                          placeholder="Enter No of time this referral can be used"
                          name="no_of_times_used"
                          value={validation.values.no_of_times_used || ""}
                          onBlur={validation.handleBlur}
                          onChange={validation.handleChange}
                          invalid={
                            validation.errors.no_of_times_used &&
                            validation.touched.no_of_times_used
                          }
                          disabled={!validation.values.referral_status}
                        />
                        {validation.touched.no_of_times_used &&
                          validation.errors.no_of_times_used ? (
                          <FormFeedback type="invalid">
                            {validation.errors.no_of_times_used}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>

          </Row>
          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader>
                  <Nav className="nav-tabs-custom card-header-tabs border-bottom-0">
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: customActiveTab === "1",
                        })}
                        onClick={() => {
                          toggleCustom("1");
                        }}
                      >
                        Variants
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: customActiveTab === "2",
                        })}
                        onClick={() => {
                          toggleCustom("2");
                        }}
                      >
                        Gallery
                      </NavLink>
                    </NavItem>
                  </Nav>
                </CardHeader>
                <CardBody>
                  <TabContent activeTab={customActiveTab}>
                    <TabPane id="addproduct-general-info" tabId="1">
                      <Row>
                        <div className="table-responsive mt-3">
                          <Table bordered responsive className="plan-subscription-table" style={{ backgroundColor: '#f8fafc' }}>
                            <thead>
                              <tr className="fw-bold" style={{ backgroundColor: '#e2e8f0' }}>
                                <th className="text-center" style={{ width: '5%', color: '#334155' }}>S.No</th>
                                <th className="text-center" style={{ minWidth: '180px', color: '#334155' }}>
                                  Product <span className="text-danger">*</span>
                                  <div className="text-muted small fw-normal">Select from list & Category</div>
                                </th>
                                <th className="text-center" style={{ minWidth: '150px', color: '#334155' }}>
                                  Variant <span className="text-danger">*</span>
                                  <div className="text-muted small fw-normal">Select variant</div>
                                </th>
                                <th className="text-center" style={{ minWidth: '120px', color: '#334155' }}>
                                  Variant Info
                                  <div className="text-muted small fw-normal">Value & Unit</div>
                                </th>
                                <th className="text-center" style={{ minWidth: '140px', color: '#334155' }}>
                                  Validity & Free Days <span className="text-danger">*</span>
                                  <div className="text-muted small fw-normal">Duration</div>
                                </th>
                                <th className="text-center" style={{ minWidth: '140px', color: '#334155' }}>
                                  Amounts <span className="text-danger">*</span>
                                  <div className="text-muted small fw-normal">Pricing</div>
                                </th>
                                <th className="text-center" style={{ minWidth: '180px', color: '#334155' }}>
                                  Offer Details
                                  {(validation.values.details?.some((d: any) => (d.offer_value && +d.offer_value !== 0) ||
                                    validation.values.details?.some((d: any) => (d.offer_type && +d.offer_type !== 0))) &&
                                    <span className="text-danger">*</span>)}
                                  <div className="text-muted small fw-normal">Choose offer type first</div>
                                </th>
                                <th className="text-center" style={{ minWidth: '140px', color: '#334155' }}>
                                  Gross Amt
                                  <div className="text-muted small fw-normal">Auto-calculated</div>
                                </th>
                                <th className="text-center" style={{ minWidth: '80px', color: '#334155' }}>
                                  Bonus
                                  <div className="text-muted small fw-normal">Loyalty</div>
                                </th>
                                <th className="text-center" style={{ minWidth: '100px', color: '#334155' }}>
                                  Actions
                                  <div className="text-muted small fw-normal">Manage</div>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <FieldArray validateOnChange={false} name="details">
                                {() => validation.values.details.map((item: any, index: number) => (
                                  <React.Fragment key={index}>
                                    <tr className="align-middle" style={{ backgroundColor: index % 2 === 0 ? '#ffffff' : '#f1f5f9' }}>
                                      {/* S.No */}
                                      <td className="text-center fw-bold" style={{ color: '#475569' }}>{index + 1}</td>

                                      {/* Product Dropdown */}
                                      <td>
                                        <Input
                                          type="select"
                                          className="form-select-sm"
                                          name={`details[${index}].product_id`}
                                          value={item.product_id || ""}
                                          onChange={(e) => {
                                            const val = parseInt(e.target.value);
                                            handleProductChange(index, val);
                                          }}
                                          onBlur={validation.handleBlur}
                                          invalid={
                                            validation.errors.details?.[index]?.product_id &&
                                            validation.touched.details?.[index]?.product_id
                                          }
                                          style={{ borderWidth: '2px' }}
                                        >
                                          <option value="" disabled>Select Product</option>
                                          {productList?.map(product => (
                                            <option
                                              key={product.id}
                                              value={product.id}
                                            >
                                              {product.name}
                                            </option>
                                          ))}
                                        </Input>
                                        <Input
                                          type="hidden"
                                          name={`details[${index}].category_id`}
                                          value={item.category_id || ""}
                                        />
                                        {validation.errors.details?.[index]?.product_id &&
                                          validation.touched.details?.[index]?.product_id && (
                                            <div className="text-danger small mt-1">
                                              <i className="ri-alert-fill me-1"></i>
                                              {validation.errors.details[index].product_id}
                                            </div>
                                          )}
                                        {item.product_id > 0 && productList.find(p => p.id === item.product_id)?.variants?.filter((v: any) => {
                                          const isUsed = validation.values.details.some((d: any, i: number) =>
                                            i !== index && Number(d.product_id) === Number(item.product_id) && Number(d.productPriceId) === Number(v.id)
                                          );
                                          return !isUsed;
                                        }).length === 0 && (
                                            <div className="text-danger small mt-1">
                                              <i className="ri-error-warning-fill me-1"></i>
                                              no have remaining variants ({productList.find(p => p.id === item.product_id)?.variants?.map((v: any) => `${v.variant_value}${v.variant?.name || ''}`).join(', ')})
                                            </div>
                                          )}
                                        
                                        <div className="mt-2 d-flex align-items-center gap-1">
                                          <small className="text-muted">Category:</small>
                                          <span className="badge bg-light text-success border">
                                            {productList.find(p => p.id === item.product_id)?.categories?.name || "N/A"}
                                          </span>
                                        </div>
                                      </td>

                                      {/* Variant Selection (ProductPriceId) */}
                                      <td>
                                        <Input
                                          type="select"
                                          className="form-select-sm"
                                          name={`details[${index}].productPriceId`}
                                          value={item.productPriceId || ""}
                                          onChange={(e) => {
                                            const val = parseInt(e.target.value);
                                            handleVariantChange(index, val);
                                          }}
                                          disabled={!item.product_id}
                                          invalid={validation.errors.details?.[index]?.productPriceId && validation.touched.details?.[index]?.productPriceId}
                                          style={{ borderWidth: '2px' }}
                                        >
                                          <option value="" disabled>{item.product_id ? 'Select Variant' : 'Select Product First'}</option>
                                          {productList.find(p => p.id === item.product_id)?.variants?.filter((v: any) => {
                                            const isUsed = validation.values.details.some((d: any, i: number) =>
                                              i !== index && Number(d.product_id) === Number(item.product_id) && Number(d.productPriceId) === Number(v.id)
                                            );
                                            return !isUsed;
                                          }).map((v: any) => (
                                            <option key={v.id} value={v.id}>
                                              {v.variant_value} {v.variant?.name || ''} - ₹{v.actual_amount}
                                            </option>
                                          ))}
                                        </Input>
                                        {validation.errors.details?.[index]?.productPriceId &&
                                          validation.touched.details?.[index]?.productPriceId && (
                                            <div className="text-danger small mt-1">
                                              <i className="ri-error-warning-line me-1"></i>
                                              {validation.errors.details[index].productPriceId}
                                            </div>
                                          )}
                                        <div className="text-muted mt-1" style={{ fontSize: '10px' }}>
                                          <i className="ri-information-fill text-info me-1"></i>
                                          {item.product_id ? 'Choose a variant to update price info' : 'Select product to see variants'}
                                        </div>
                                      </td>

                                      {/* Variant Info (Display only) */}
                                      <td>
                                        <div className="d-flex flex-column gap-2 mt-1">
                                          <div className="badge bg-light text-dark border text-start fw-normal" style={{ fontSize: '10px' }}>
                                            <i className="ri-lock-2-fill text-muted me-1"></i> Read Only: Auto-set
                                          </div>
                                          <Input
                                            type="text"
                                            className="form-control-sm bg-light"
                                            name={`details[${index}].variant_value`}
                                            value={item.variant_value || ""}
                                            readOnly
                                            placeholder="Value"
                                            style={{ borderWidth: '2px' }}
                                          />
                                          <Input
                                            type="select"
                                            className="form-select-sm bg-light"
                                            name={`details[${index}].variant_id`}
                                            value={item.variant_id || ""}
                                            disabled
                                            style={{ borderWidth: '2px' }}
                                          >
                                            <option value="" disabled>Unit</option>
                                            {availableVariants?.map(variant => (
                                              <option key={variant.id} value={variant.id}>{variant.name}</option>
                                            ))}
                                          </Input>
                                        </div>
                                      </td>

                                      {/* Validity & Free Days */}
                                      <td>
                                        <div className="d-flex flex-column gap-2">
                                          <div className="input-group input-group-sm">
                                            <span className="input-group-text bg-light">Days</span>
                                            <Input
                                              type="number"
                                              className="form-control"
                                              name={`details[${index}].validity`}
                                              value={item.validity}
                                              onChange={(e) => handleCombinationChange(index, "validity", e.target.value)}
                                              invalid={validation.errors.details?.[index]?.validity && validation.touched.details?.[index]?.validity}
                                            />

                                          </div>
                                          <div className="input-group input-group-sm">
                                            <span className="input-group-text bg-light">+ Free</span>
                                            <Input
                                              type="number"
                                              className="form-control"
                                              name={`details[${index}].free_validity_days`}
                                              value={item.free_validity_days}
                                              onChange={(e) => handleCombinationChange(index, "free_validity_days", e.target.value)}
                                              invalid={validation.errors.details?.[index]?.free_validity_days && validation.touched.details?.[index]?.free_validity_days}
                                            />
                                          </div>
                                        </div>
                                      </td>

                                      {/* Per Day & Actual Amt */}
                                      <td>
                                        <div className="d-flex flex-column gap-3">
                                          <div className="input-group input-group-sm">
                                            <span className="input-group-text bg-light">Per Day</span>
                                            <Input
                                              type="number"
                                              className="form-control"
                                              name={`details[${index}].per_day_amount`}
                                              value={item.per_day_amount}
                                              onChange={(e) => handleCombinationChange(index, "per_day_amount", e.target.value)}
                                              invalid={validation.errors.details?.[index]?.per_day_amount && validation.touched.details?.[index]?.per_day_amount}
                                            />
                                          </div>
                                          <div className="input-group input-group-sm">
                                            <span className="input-group-text bg-light">Actual</span>
                                            <Input
                                              type="number"
                                              className="form-control"
                                              name={`details[${index}].actual_amount`}
                                              value={item.actual_amount}
                                              onChange={(e) => handleCombinationChange(index, "actual_amount", e.target.value)}
                                              invalid={validation.errors.details?.[index]?.actual_amount && validation.touched.details?.[index]?.actual_amount}
                                            />
                                          </div>
                                        </div>
                                      </td>

                                      {/* Offer Details */}
                                      <td>
                                        <div className="d-flex flex-column gap-2">
                                          <div className="d-flex justify-content-center gap-2">
                                            <Button
                                              color={Number(item.offer_type) === 1 ? "primary" : "light"}
                                              className={`${Number(item.offer_type) === 1 ? 'active' : ''}`}
                                              onClick={() => {
                                                const newType = Number(item.offer_type) === 1 ? 0 : 1;
                                                handleCombinationChange(index, "offer_type", newType);
                                              }}
                                              size="sm"
                                            >
                                              <i className="ri-money-rupee-circle-fill me-1"></i> Amt
                                            </Button>
                                            <Button
                                              color={Number(item.offer_type) === 2 ? "primary" : "light"}
                                              className={`${Number(item.offer_type) === 2 ? 'active' : ''}`}
                                              onClick={() => {
                                                const newType = Number(item.offer_type) === 2 ? 0 : 2;
                                                handleCombinationChange(index, "offer_type", newType);
                                              }}
                                              size="sm"
                                            >
                                              <i className="ri-percent-fill me-1"></i> Percent
                                            </Button>
                                          </div>

                                          <Input
                                            type="number"
                                            className="form-control-sm border-success"
                                            name={`details[${index}].offer_value`}
                                            value={item.offer_value}
                                            onChange={(e) => handleCombinationChange(index, "offer_value", e.target.value)}
                                            placeholder={item.offer_type === 1 ? "Enter discount amount" : "Enter discount %"}
                                            invalid={validation.errors.details?.[index]?.offer_value && validation.touched.details?.[index]?.offer_value}
                                            style={{ borderWidth: '2px' }}
                                          />

                                          {(item.offer_value || item.free_validity_days) && (
                                            <div className="alert alert-success p-1 mb-0 text-center small">
                                              <i className="ri-checkbox-circle-fill me-1"></i>
                                              Total Discount: ₹{
                                                (
                                                  item.free_validity_days > 0
                                                    ? parseFloat(item.free_validity_days || "0") * parseFloat(item.per_day_amount || "0")
                                                    : item.offer_type === 1
                                                      ? parseFloat(item.offer_value || "0")
                                                      : item.offer_type === 2
                                                        ? (parseFloat(item.actual_amount || "0") * parseFloat(item.offer_value || "0")) / 100
                                                        : 0
                                                ).toFixed(2)
                                              } {""}{
                                                item.offer_type === 2 ? `(${item.offer_value}%) ` : ''
                                              }
                                              {item.free_validity_days > 0 && (
                                                <span> (Includes {item.free_validity_days} free days)</span>
                                              )}
                                            </div>
                                          )}

                                        </div>
                                      </td>

                                      {/* Gross Amt */}
                                      <td>
                                        <div className=" d-flex justify-content-center gap-0 input-group input-group-sm w-100 ">
                                          <span className="input-group-text bg-light">Total</span>
                                          <Input
                                            type="number"
                                            className="form-control bg-light"
                                            name={`details[${index}].gross_amount`}
                                            value={item.gross_amount}
                                            placeholder="Gross amount"
                                            invalid={validation.errors.details?.[index]?.gross_amount && validation.touched.details?.[index]?.gross_amount}
                                            onChange={(e) => handleCombinationChange(index, "gross_amount", e.target.value)}
                                          />
                                        </div>
                                      </td>

                                      {/* Bonus */}
                                      <td className="text-center">
                                        <div className="d-flex flex-column align-items-center">
                                          <div className="form-check form-switch mb-1">
                                            <Input
                                              type="checkbox"
                                              className="form-check-input"
                                              name={`details[${index}].is_loyalty_bonus`}
                                              checked={item.is_loyalty_bonus || false}
                                              onChange={(e) => validation.setFieldValue(
                                                `details[${index}].is_loyalty_bonus`,
                                                e.target.checked
                                              )}
                                              style={{ cursor: 'pointer', width: '3em', height: '1.5em' }}
                                            />
                                          </div>
                                          <small className={`fw-bold ${item.is_loyalty_bonus ? 'text-success' : 'text-muted'}`}>
                                            {item.is_loyalty_bonus ? (
                                              <span className="badge bg-success bg-opacity-25 text-success">
                                                <i className="ri-gift-fill me-1"></i> Bonus Included
                                              </span>
                                            ) : (
                                              <span className="badge bg-light text-muted border">
                                                <i className="ri-gift-line me-1"></i> No Bonus
                                              </span>
                                            )}
                                          </small>
                                        </div>
                                      </td>
                                      {/* Actions */}
                                      <td className="text-center">
                                        <div className="d-flex justify-content-center gap-0">
                                          {(index === validation.values.details.length - 1) && (
                                            <Button
                                              color="success"
                                              className="btn-icon rounded-circle"
                                              onClick={handleAddRow}
                                              size="sm"
                                              title="Add new row"
                                            >
                                              <i className="ri-add-line"></i>
                                            </Button>
                                          )}
                                          {(validation.values.details.length > 1) && (
                                            <Button
                                              color="danger"
                                              className="btn-icon rounded-circle"
                                              onClick={() => handleRemoveRow(index)}
                                              size="sm"
                                              title="Remove this row"
                                            >
                                              <i className="ri-delete-bin-line"></i>
                                            </Button>
                                          )}
                                        </div>
                                      </td>
                                    </tr>

                                    {/* Error row if any - Only show when there are validation errors */}
                                    {validation.errors.details?.[index] && Object.keys(validation.errors.details[index] as any).length > 0 && (
                                      <tr key={`error-${index}`}>
                                        <td colSpan={10} className="p-0">
                                          <div className="alert alert-danger small px-2 py-1 m-1">
                                            <i className="ri-error-warning-fill me-1"></i>
                                            {Object.entries(validation.errors.details[index] as any).map(([key, error]: any) => (
                                              <span key={key} className="me-2">• {error}</span>
                                            ))}
                                          </div>
                                        </td>
                                      </tr>
                                    )}
                                  </React.Fragment>
                                ))}
                              </FieldArray>
                            </tbody>
                          </Table>
                        </div>
                        <div className="mt-3">
                          <Button
                            color="primary"
                            className="btn-label"
                            onClick={handleAddRow}
                          >
                            <i className="ri-add-line label-icon align-middle fs-16 me-2"></i>
                            Add Row
                          </Button>
                        </div>
                      </Row>
                    </TabPane>
                    <TabPane tabId="2">
                      <Row className="mt-4">
                        <Col lg={12}>
                          <div className="mb-4">
                            <h5 className="fs-14 mb-1">Subscription Gallery</h5>
                            <p className="text-muted">Add/Manage Gallery Images for this subscription.</p>

                            <Dropzone
                              onDrop={(acceptedFiles) => {
                                handleAcceptedFiles(acceptedFiles);
                              }}
                            >
                              {({ getRootProps, getInputProps }) => (
                                <div className="dropzone dz-clickable bg-light border-dashed">
                                  <div
                                    className="dz-message needsclick text-center p-5"
                                    {...getRootProps()}
                                  >
                                    <input {...getInputProps()} />
                                    <div className="mb-3">
                                      <i className="display-4 text-muted ri-upload-cloud-2-fill" />
                                    </div>
                                    <h5 className="mb-0">Drop files here or click to upload.</h5>
                                  </div>
                                </div>
                              )}
                            </Dropzone>

                            <Row className="mt-4">
                              {newGalleryFiles.map((image, index) => (
                                <Col xl={3} md={4} sm={6} key={image.id} className="mb-3">
                                  <Card className="h-100 border shadow-none mb-0">
                                    <div className="position-relative">
                                      <img
                                        src={image.preview}
                                        alt={`New Gallery ${index}`}
                                        className="card-img-top img-fluid rounded"
                                        style={{ height: '160px', width: '100%', objectFit: 'cover' }}
                                      />
                                      <div className="position-absolute top-0 end-0 p-2">
                                        <Button
                                          color="danger"
                                          size="sm"
                                          className="btn-icon rounded-circle shadow"
                                          onClick={() => removeGallery(image.id)}
                                          title="Remove image"
                                        >
                                          <i className="ri-close-line"></i>
                                        </Button>
                                      </div>
                                    </div>
                                    <CardBody className="p-2">
                                      <div className="d-flex align-items-center gap-2">
                                        <Label className="mb-0 small text-muted">Order:</Label>
                                        <Input
                                          type="number"
                                          bsSize="sm"
                                          value={image.list_order}
                                          onChange={(e) => handleGalleryOrderChange(image.id, e.target.value)}
                                          style={{ width: '60px' }}
                                        />
                                        <span className="badge bg-warning bg-opacity-10 text-warning ms-auto">
                                          New
                                        </span>
                                      </div>
                                      <div className="mt-1 text-muted" style={{ fontSize: '10px' }}>
                                        * Orders auto-shift (1 to {newGalleryFiles.length})
                                      </div>
                                    </CardBody>
                                  </Card>
                                </Col>
                              ))}
                              {newGalleryFiles.length === 0 && (
                                <Col lg={12}>
                                  <div className="text-center p-5 border rounded bg-light">
                                    <i className="ri-image-line display-4 text-muted"></i>
                                    <p className="mt-2 text-muted">No gallery images added.</p>
                                  </div>
                                </Col>
                              )}
                            </Row>
                          </div>
                        </Col>
                      </Row>
                    </TabPane>
                  </TabContent>


                </CardBody>
              </Card>
            </Col>


          </Row>
          <div className="text-end mb-3">
            <button type="submit" className="btn btn-success w-sm">
              Submit
            </button>
          </div>
          <CropModal
            isOpen={cropModal}
            toggle={() => setCropModal(false)}
            imageSrc={imageToCrop}
            onCropSave={handleCropSave}
            targetWidth={1512}
            targetHeight={448}
            title="Trial Plan Image Crop"
          />
        </Form>
      </Container>
    </div>
  );
};

export default AddPlanSubscription;
